export default {
  title: '',
  subTitle: '',
  content: '',
  underLine: {
    title: {
      isShow: true,
      width: '70px', // any number with px, compute(bigger than text), full(line/screen)
      color: null
    },
    subTitle: {
      isShow: false,
      width: 'full', // any number with px, compute(bigger than text), full(line/screen)
      color: null
    },
    content: {
      isShow: false,
      width: null, // any number with px, compute(bigger than text), full(line/screen)
      color: null
    }
  },
  styleConfig: {
    root: null
    // title: {
    //   fontSize: '32px',
    //   color: '#000'
    // },
    // subTitle: {
    //   fontSize: '14px',
    //   color: '#666666'
    // },
    // content: {
    //   fontSize: '14px'
    // }
  }
}
